<template>
  <div>
    <div class="act-hamb" v-if="isActiveHamburgerMenu">
      <div class="d-flex" style="height: 50px; align-items: center; ">
        <img src="/img/logo.png" style="width: 150px; height: 70px; margin-left: 16px" @click="goToHomePage" />
        <div style="
            justify-content: right;
            display: inline-flex;
            margin-right: 16px;
            width: 100%;
          ">
          <div @click="closeMenu">
            <close />
          </div>
        </div>
      </div>
      <div style="background: #f1f1f1; width: 100%; height: 1px"></div>
      <HamburgerMenu v-if="isActiveHamburgerMenu" @close="() => isActiveHamburgerMenu = false" />
    </div>
    <div class="header-menu container">
      <v-toolbar-title class="text-uppercase blue--text d-flex" style="align-items: center; width: 100%">
        <div style="cursor: pointer; margin-left: 16px; display: flex; align-items: center;" @click="goToHomePage">
          <LogoNav width="140" height="40" />
        </div>
        <div style="
            justify-content: right;
            display: inline-flex;
            margin-right: 16px;
            width: 100%;
          ">
          <img src="/img/other/ic_menu_white.png" style="width: 24px; height: 24px; cursor: pointer"
            @click="openMenu" />
        </div>
      </v-toolbar-title>
    </div>
    <div class="sub-banner font-poppins">
      <h1 class="title-banner font-poppins">{{ $t('home.heroSection.title') }} <span style="color: #FFDE59;"><u>{{ $t('home.heroSection.yellowTitle') }}</u></span></h1>
      <p style="color: white; text-align: left; font-size: 13px;" v-html="$t('home.heroSection.subtitle')"></p>
      <div class="btn-yellow" style="margin-right: 20px;" @click="scrollToClass('list-of-acceleration-container')">{{ $t('home.heroSection.viewProgram') }}</div>
      <div class="btn-white" @click="goToCustomerService">{{ $t('home.heroSection.contactUs') }}</div>

      <iframe class="card-image" src="https://www.youtube.com/embed/7mBp0DYzql4?si=O6Aw9SheRYdJm3a2"
        title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

      <div class="container">
        <div class="stats" style="color: white;margin-left: auto;margin-right: auto;" >
        <div class="stat-item" v-for="(i, index) in $t('home.additionalInfo')" :key="index">
          <div style="width: 100px;">
            <h3 style="margin-right: 10px;color: white;">{{i.total}}</h3>
            <span style="width: 50px;font-size: 12px;" v-html="i.title "></span>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="container mt-10">
        <h2 style="text-align: center; color: #162CA2;" v-html="$t('home.usp.title')"></h2>
        <div class="card-horizontal-scroll">
          <div v-for="(item, idx) in $t('home.usp.details')" :key="idx" class="card-horizontal-scroll-child" style="border: none;">
            <img :src="item.img" style="width: 50px;height: 50px;"/>
            <h3 class="mt-2" style="font-size: 14px;">{{ item.name }}</h3>
            <p class="mt-2" style="font-size: 12px;line-height: 20px;">{{ item.description }}</p>
          </div>
        </div>
      </div>

    <div class="container" style="margin-top: -20px;"><BannerMobile :banners="banners" /></div>

    <div class="list-of-acceleration" style="background-color: white;">
      <div class="list-of-acceleration-container">
        <h2 class="text-left my-1" style="color: #162CA2;font-size: 20px;" v-html="$t('home.accelerationProgramSection.title')"></h2>
        <div class="nav-container">
          <button v-for="(tab, index) in tabs" :key="index" :class="`tab-btn ${activeTab === tab ? 'active' : ''}`"
            @click="setActiveTab(tab)">
            {{ tab }}
          </button>
        </div>
        <div class="card" style="padding-bottom: 30px">
          <div class="items" v-for="(item, idx) in listClass" :key="idx" @click="directDetail(item.slug_name)"
            :title="item.name">
            <div style="height: 220px">
              <img :src="item.small_image_url" :alt="`${item.name}`" style="width: 100%; height: 100%; border-radius: 20px 20px 0 0" />
            </div>
            <div class="label" v-if="item.collaboration_feed">
              <img :src="item.collaboration_feed" alt="" style="width: 80%" />
            </div>
            <div class="content">
              <div style="height: 60px;">
                <h2>{{ item.name }}</h2>
              </div>
              <div class="category">
                <div style="background-color: #f1f6ff" v-if="item.level">
                  <p>{{ item.level }}</p>
                </div>
              </div>
              <div class="event-ctn-info my-2" v-if="item.session">
                <NoteIcon :width="25" fill="#575966" />
                <span class="name">{{ item.session }} {{ $t('home.a2') }}</span>
              </div>
              <div class="event-ctn-info my-2" v-if="activeTab != 'Event'">
                <AwardIcon :width="25" fill="#575966" />
                <span class="name">Reguler / Private</span>
              </div>
              <div class="event-ctn-info" v-if="item.days">
                <DateIcon :width="22" fill="#575966" />
                <span class="name">{{ item.days }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.hours">
                <clock :width="22" fill="#575966" />
                <span class="name">{{ item.hours }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.method">
                <methode :width="22" fill="#575966" />
                <span class="name">{{ item.method | toMethode }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="div-for-corporate">
      <div class="list-of-acceleration-container">
        <p class="margin-0" style="font-weight: 500; color: #36373F; font-size: 16px;">{{
          $t('home.accelerationPrograms.corporateServiceSection.title') }}</p>
        <h2 style="text-align: left; margin-top: -12px;color: #162CA2;" v-html="$t('home.accelerationPrograms.corporateServiceSection.subtitle')"></h2>
        <p class="margin-0"
          style="font-weight: 400; margin-top: -18px; margin-bottom: 32px; color: #36373F; font-size: 15px;">{{
            $t('home.accelerationPrograms.corporateServiceSection.description') }}</p>
        <div class="card-1" v-for="(item, idx) in $t('home.descs1')" :key="idx">
          <img :src="item.img" class="img-2" style="width: 56px; height: 56px;" />
          <div class="mt-2">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
          <div class="btn-stoke-blue" style="background-color: #162CA2; color: white;"
            @click="navigateWithRouter(item.url, '')" >
            <span class="font-poppins">{{ $t('home.learnMore') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="marquee-container">
        <div style="text-align: center;"><h2 style="color: #162CA2;font-size: 16px;">{{ $t('home.titleLogoPartner') }}</h2></div>
        <div class="marquee-wrapper">
          <div class="our-client">
            <img v-for="(item, idx) in ourPartners" :key="idx" :src="item.img_url_mobile" class="image-client" />
          </div>
        </div>
      </div>
    </div>
    
    <div class="div-testimonies" style="background-color: white; padding: 40px 0;">
      <div class="container">
        <h2 style="text-align: center; margin-top: -12px;color: #162CA2;" v-html="$t('home.accelerationPrograms.testimonySection.title')"></h2>
        <div class="card-horizontal-scroll">
            <div v-for="(item, idx) in testimonies" :key="idx" class="card-horizontal-scroll-child">
                <img src="/img/home/quote.png" alt="main" style="width: 24px; height: 24px">
                <p class="text-left mt-2" style="height: 310px; font-size: 14px;">{{ item.feedback }}</p>
                <div class="profile mt-5 d-flex" style="align-items: center">
                <div class="avatar">
                  <v-img :src="$utils.loadImage(item.image_url)" alt="" width="60" height="60" class="avatar-image" />
                </div>
                <div class="testi-profile ml-5">
                  <div class="name">{{ item.name }}</div>
                  <div class="description">
                    {{ item.job }} {{ item.place }}
                  </div>
                  <v-img v-if="item.linkedin" src="/img/home/linkedin.png" alt="" width="23" height="23"
                    @click="redirectReload(item.linkedin)" class="linkedin-image cursor-pointer" />
                </div>
              </div>
            </div>
        </div>
        <div class="btn-stoke-blue" style="margin-top: 40px; background-color: white;"
          @click="$router.push('/testimony')">
          <span class="font-poppins">{{ $t('home.a1') }}</span>
          <ArrowLong />
        </div>
      </div>
    </div>

    <div class="mt-15" @click="goToCustomerService">
      <img src="/img/home/contact-us-mob.png" alt="main" style="width: 100%; height: 100%;cursor: pointer;">
    </div>

    <div class="faqbg">
      <div class="faq">
        <h1 style="color: #162CA2; text-align: center;" v-html="$t('faqHeroTitle')"></h1>
        <div class="container">
          <AccordeonFaq v-for="(item, index) in questions" :key="index" :title="item.title"
            :description="item.description" :active="item.active" @toggle="toggleAccordion(index)" />
          <div class="btn-stoke-blue cursor-pointer" @click="$router.push('/faq')"
            style="background-color: white; margin-top: 30px;">
            <span class="font-poppins">{{ $t('home.a1') }}</span>
            <ArrowLong />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import HamburgerMenu from '@/components/HamburgerMenu';
import LogoNav from '@/assets/icons/LogoNav.vue';
import BannerMobile from '../BannerMobile.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import AccordeonFaq from '@/components/AccordeonFaq.vue';
import NoteIcon from '@/assets/icons/Note.vue';
import AwardIcon from '@/assets/icons/Award.vue';
import Close from '@/assets/icons/Close.vue';
import goTo from 'vuetify/lib/services/goto';

export default {
  components: {
    Close,
    NoteIcon,
    AwardIcon,
    ArrowLong,
    LogoNav,
    BannerMobile,
    HamburgerMenu,
    AccordeonFaq,
  },
  data() {
    return {
      mobileView: false,
      is_login_show: false,
      isActiveHamburgerMenu: false,
      questions: [],
      testimonies: [],
      accelerations: [],
      ourPartners: [],
      events: [],
      banners: [],
      bootcampClass: [],
      listClass: [],
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      tabs: ['Bootcamp', 'Certification', 'Event'],
      activeTab: 'Bootcamp',
    };
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
  },
  watch: {
    '$i18n.locale'() {
      this.setActiveTab(this.activeTab);
      this.getFaq();
      this.getTestimoni();
    },
  },
  methods: {
    scrollToClass(className) {
      const element = document.querySelector(`.${className}`);
      if (element) {
        goTo(element.offsetTop, {
          duration: 600,
          easing: 'easeInOutCubic'
        });
      }
    },
    navigateWithRouter(route, slug){
      if(route != ""){
        this.$router.push(route + slug);
      }
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.$gtag.event('click', {
        event_category: 'Tab',
        event_label: `Tab - ${tab}`,
        value: 1,
      });
      if (tab === 'Bootcamp') {
        this.getBootcampClass();
      } else if (tab === 'Certification') {
        this.getAccelerationClass();
      } else {
        this.getDataEvents();
      }
    },
    directDetail(slugName) {
      const item = this.listClass.find(item => item.slug_name === slugName);
      if (item) {
        this.$gtag.event('view_item', {
          event_category: 'E-commerce',
          event_label: item.name,
          value: item.price || 0,
          items: [
            {
              item_id: item.slug_name,
              item_name: item.name,
              item_category: this.activeTab,
              price: item.price || 0,
              quantity: 1,
            },
          ],
        });
      }
      if (this.activeTab === 'Bootcamp') {
        this.$router.push(`/class/bootcamp/${slugName}`);
      } else if (this.activeTab === 'Certification') {
        this.$router.push(`/certification/detail/${slugName}`);
      } else {
        this.$router.push(`/event/detail/${slugName}`);
      }
    },
    directOther() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `${this.activeTab} See More Button`,
        value: 1,
      });
      if (this.activeTab === 'Bootcamp') {
        this.$router.push('/class/bootcamp');
      } else if (this.activeTab === 'Certification') {
        this.$router.push('/certification');
      } else {
        this.$router.push('/event');
      }
    },
    openMenu() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Open Hamburger Menu',
        value: 1,
      });
      this.isActiveHamburgerMenu = true;
    },
    closeMenu() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Close Hamburger Menu',
        value: 1,
      });
      this.isActiveHamburgerMenu = false;
    },
    goToCustomerService() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Customer Service WhatsApp',
        value: 1,
      });
      window.location.href =
        'https://api.whatsapp.com/send/?phone=6285110563798&text=Hi Kak HiColleagues, saya mau bertanya';
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(`/v1/testimony?category=HOME&page=1&per_page=3`);
        this.testimonies = resp.data.data.testimonies;
      } catch (err) {
        console.log(err);
      }
    },
    toggleAccordion(index) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `FAQ - ${this.questions[index].title}`,
        value: 1,
      });
      this.questions[index].active = !this.questions[index].active;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=HOME&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    async getBanners() {
      await this.$http
        .get('/v1/banner?category=GENERAL&is_active=true')
        .then((response) => {
          this.banners = response.data.data.banners;
        })
        .catch((err) => console.error(err.response));
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get('/v1/logo?category=CORPORATE');
        this.ourPartners = resp.data.data.logos;
      } catch (err) {
        console.log(err);
      }
    },
    async getBootcampClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/5?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getAccelerationClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/6?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getDataEvents() {
      try {
        const resp = await this.$http.get(`/v1/event?is_active=true`);
        this.listClass = resp.data.data.events.map((item) => ({
          ...item,
          small_image_url: item.img_urls.mobile.thumbnail,
          session: item.total_session,
          days: '',
          hours: `${item.session_schedules[0].start_time} - ${item.session_schedules[0].end_time} WIB`,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    goToHomePage() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Home Page',
        value: 1,
      });
      this.$router.push({ path: '/' }).then(() => {
        this.$router.go();
      });
    },
    goToEvent() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Event Button',
        value: 1,
      });
      this.$router.push({ path: '/event' }).then(() => {
        this.$router.go();
      });
    },
    goToCertification() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Certification Button',
        value: 1,
      });
      this.$router.push({ path: '/certification' }).then(() => {
        this.$router.go();
      });
    },
    goToCorporateTraining() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Pelatihan Karyawan Button',
        value: 1,
      });
      this.$router.push('/corporate/training');
    },
    toDiscount(item) {
      const total_price = item.price - item.discount;
      if (total_price <= 0) {
        return 'FREE';
      } else {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return formatter.format(total_price);
      }
    },
    redirectReload(e) {
      if (e.slice(0, 5) == 'https') {
        this.$gtag.event('click', {
          event_category: 'Social Media',
          event_label: `LinkedIn Testimony - ${e}`,
          value: 1,
        });
        window.open(e, '_blank');
      } else {
        this.$gtag.event('click', {
          event_category: 'Navigation',
          event_label: `Router - ${e}`,
          value: 1,
        });
        this.$router.push({ path: e }).then(() => {
          this.$router.go();
        });
      }
    },
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === 'online') {
        return 'Daring';
      } else if (value.toLowerCase() === 'offline') {
        return 'Luring';
      } else {
        return value;
      }
    },
    toDetailPrakerja(item) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Prakerja Detail - ${item.slug_name}`,
        value: 1,
      });
      this.$router.push('/class/prakerja/' + item.slug_name);
    },
    discountPercent(event) {
      return Math.round(((event.price - (event.price - event.discount_price)) / event.price) * 100);
    },
    countDownTimer() {
      const _second = 1000;
      const _minute = _second * 60;
      const _hour = _minute * 60;
      const _day = _hour * 24;
      let days, hours, minutes, seconds;
      const showRemaining = () => {
        this.events.forEach((item2) => {
          const end = new Date(item2.registration_close_date);
          const now = new Date();
          const distance = end - now;
          if (distance < 0) {
            item2.expired = [];
            return;
          }
          days = Math.floor(distance / _day);
          hours = Math.floor((distance % _day) / _hour);
          minutes = Math.floor((distance % _hour) / _minute);
          seconds = Math.floor((distance % _minute) / _second);
          item2.expired = [days, hours, minutes, seconds];
        });
      };
      setInterval(showRemaining, 1000);
    },
    checkIsEarlyBird(item) {
      if (new Date(item.start_discount_date) <= new Date() && new Date(item.end_discount_date) >= new Date()) {
        return true;
      } else {
        return false;
      }
    },
    moment(date, val) {
      if (!val) {
        return moment(date).format('dddd, DD MMMM YYYY');
      }
      return moment(date).format(val);
    },
    async getTotalRegistran(id) {
      try {
        const resp = await this.$http.get(`/v1/event/${id}/registrant`);
        return resp.data.data.total_registrants;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    toDetail(item) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Event Detail - ${item.slug_name}`,
        value: 1,
      });
      this.$router.push('/event/detail/' + item.slug_name);
    },
    async toCheckout(item) {
      const total_registrants = await this.getTotalRegistran(item.id);
      if (total_registrants >= item.participant_quota && item.participant_quota !== 0) {
        this.notif.isAlertErr = true;
        this.notif.alertErrMessage = 'Kouta pendaftaran sudah penuh';
        return;
      }
      this.$gtag.event('add_to_cart', {
        event_category: 'E-commerce',
        event_label: item.name,
        value: item.price || 0,
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            item_category: 'Event',
            price: item.price || 0,
            quantity: 1,
          },
        ],
      });
      this.$router.push('/checkout/event/' + item.slug_name);
    },
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  mounted() {
    this.getBanners();
    this.getBootcampClass();
    this.getClientLogo();
    this.getFaq();
    // this.countDownTimer();
    this.getTestimoni();
  },
};
</script>

<style src="./home.css" scoped></style>